<template>

	<div>
		<van-nav-bar class="navbar" title="升级" />
		<div class="images">
			<img src="../../assets/images/upup.png" alt="">
		</div>
		<div class="text">您当前的版本过低，请先升级喔</div>
	</div>

</template>

<script>
	import {
		NavBar,
		Picker,
		List,
		PullRefresh,
		Toast,
		Popup,
	} from "vant";
	Vue.use(Picker);
	Vue.use(List);
	Vue.use(PullRefresh);
	Vue.use(Popup);
	Vue.use(PullRefresh);
	import {
		getUserId,
		globaluserId,
		responseUtil
	} from "../../libs/rongxunUtil";
	import rxNavBar from "../../components/rongxun/rx-navBar/navBar";
	import Vue from 'vue';
	import dialMobile from '../../components/rongxun/rx-dialMobile/dialMobile'

	export default {
		name: "myOrder",
		data() {
			return {}
		},
		components: {
			[NavBar.name]: NavBar,
			[List.name]: List,
			[PullRefresh.name]: PullRefresh,
			dialMobile,
			rxNavBar
		},
		created() {},
		mounted() {},
		methods: {
			//返回上一页
			leftReturn() {
				this.$router.go(-1)
			},
		},

	}
</script>

<style scoped>
	.images{
		margin:0 auto;
		margin-top: 28%;
		text-align: center;
	}
	
	.images img{
		width: 80%;
	}
	
	.text{
		text-align: center;
		font-size: 16px;
		font-weight: 700;
		color: #1d8ffa;
		background: linear-gradient(to right, red, blue);
		        -webkit-background-clip: text;
		        color: transparent;
	}
</style>
